import { Text } from "@/components/atoms/Text";
import { ListingSaveButton } from "~/components/save/listing-save-button";
import { ListingShareButton } from "~/components/share/listing-share-button";
import { IListingShare } from "~/types/api-types";

import { LocationBreadcrumbs } from "./location-breadcrumbs";

interface HeaderProps {
  category: string;
  cityGoogle: string;
  emailShare: string;
  fbShare: IListingShare;
  isFav: boolean;
  isMDScreen: boolean;
  listingId: string;
  listingVenueName?: string;
  metro: string;
  neighborhood?: string;
  neighborhoodBreadcrumb?: string;
  state?: string;
  stateGoogle: string;
  title: string;
  twitterShare: IListingShare;
  useType: string;
  useTypeBreadcrumb: string;
  toggleFavorite: () => void;
}

export const Header = ({
  category,
  cityGoogle,
  emailShare,
  fbShare,
  isFav,
  isMDScreen,
  listingId,
  listingVenueName,
  metro,
  neighborhood,
  neighborhoodBreadcrumb,
  state,
  stateGoogle,
  title,
  twitterShare,
  useType,
  useTypeBreadcrumb,
  toggleFavorite,
}: HeaderProps) => {
  return (
    <div className="col-xs-12 sm:tw-my-24 tw-grid tw-grid-cols-2 tw-gap-4 tw-w-full">
      <div className="sm:tw-col-span-1 tw-col-span-2">
        {listingVenueName && (
          <Text
            element="h1"
            typeface="headline-4-m"
            className="tw-truncate tw-m-0 tw-pb-4"
            data-testing-id="brandNameLabel"
          >
            {listingVenueName}
          </Text>
        )}
        <Text
          element="h1"
          typeface={listingVenueName ? "body-2-m" : "headline-4-m"}
          data-testing-id="listingHeader"
        >
          {title}
        </Text>
        <LocationBreadcrumbs
          state={state}
          cityGoogle={cityGoogle}
          stateGoogle={stateGoogle}
          neighborhood={neighborhood}
          neighborhoodBreadcrumb={neighborhoodBreadcrumb}
          useTypeBreadcrumb={useTypeBreadcrumb}
        />
      </div>
      <div className="sm:tw-col-span-1 tw-items-start tw-hidden sm:tw-flex tw-gap-16 tw-justify-end">
        <ListingShareButton
          origin={"share listing details"}
          useType={useType}
          metro={metro}
          category={category}
          fbShare={fbShare}
          twitterShare={twitterShare}
          emailShare={emailShare}
          isMDScreen={isMDScreen}
          variant="ghost"
        />
        <ListingSaveButton
          toggleFavorite={toggleFavorite}
          listingId={listingId}
          isFav={isFav}
          isMDScreen={isMDScreen}
          variant="ghost"
        />
      </div>
    </div>
  );
};
